import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { imagineContrasts } from '../data/content';
export function Imagine() {
  return <section className="w-full bg-ink px-5 py-20 text-white sm:py-28" data-id="element-139" data-mp="ixkba1fr787h">
      <div className="mx-auto max-w-4xl" data-id="element-140" data-mp="e5iovmovg13q">
        <h2 className="mx-auto max-w-3xl text-center font-display text-[1.75rem] font-black leading-tight tracking-tight sm:text-5xl" data-id="element-141" data-mp="e47m9q75wze7">
          Imagine Your Next Planning Session{' '}
          <span className="text-sun" data-id="element-142" data-mp="5771dtjaxjfi">Looking Different.</span>
        </h2>

        <ul className="mt-14 divide-y divide-white/10 border-y border-white/10" data-id="element-143" data-mp="5hos9gfkxpb">
          {imagineContrasts.map(item => <li key={item.after} className="grid items-center gap-3 py-7 md:grid-cols-[1fr_auto_1fr] md:gap-8" data-id="element-144" data-mp="3rdlszawui0jw">
              <p className="text-sm leading-relaxed text-white/50 line-through decoration-white/30 sm:text-base" data-id="element-145" data-mp="3nd1vu7c9uwxr">
                {item.before}
              </p>
              <ArrowRightIcon className="hidden h-5 w-5 text-sun md:block" aria-hidden="true" data-id="element-146" data-mp="1ljm3n60jda0o" />
              <p className="font-display text-lg font-bold leading-snug text-sun sm:text-xl" data-id="element-147" data-mp="a0u4dhbdyo31">
                {item.after}
              </p>
            </li>)}
        </ul>

        <div className="mt-16 text-center" data-id="element-148" data-mp="10f51e1l78gj">
          <h3 className="mx-auto max-w-2xl font-display text-2xl font-black leading-tight tracking-tight sm:text-3xl" data-id="element-149" data-mp="11gskhzshnf5">
            That’s the Difference Between Collecting Ideas and Having a System.
          </h3>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/70" data-id="element-150" data-mp="ss4tbsxjwqsa">
            Your preparation has a starting point. Your lesson has a direction.
            And your evening doesn’t have to revolve around building everything
            from scratch.
          </p>
        </div>
      </div>
    </section>;
}